import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { getObeDetails as getObeDetailsSelector } from 'api/obes/getObeDetails';
import { BackButton } from 'components/Button';
import Spinner from 'components/Spinner/Spinner';
import { LargeHeader, Title } from 'components/Text';
import { AGREEMENTS } from 'routes/overview/paths';
import checkLoadable from 'utils/recoil/checkLoadable';
import TagInfo from './TagInfo/TagInfo';
import TagPassings from './TagPassings/TagPassings';
import VehicleInfo from './VehicleInfo/VehicleInfo';
export default function TagDetails() {
  const {
    t
  } = useTranslation();
  const {
    tagNumber
  } = useParams();
  const getObeDetails = useRecoilValueLoadable(getObeDetailsSelector(tagNumber));
  const {
    contents,
    loading
  } = checkLoadable(getObeDetails);
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  if (!contents && !loading) return /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('error.no_tag'));
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BackButton, {
    to: AGREEMENTS
  }, /*#__PURE__*/React.createElement(LargeHeader, null, t('tag.tag_details.tag_details'))), /*#__PURE__*/React.createElement(TagInfo, {
    tag: contents
  }), /*#__PURE__*/React.createElement(VehicleInfo, {
    tag: contents
  }), /*#__PURE__*/React.createElement(TagPassings, {
    tagNumber: tagNumber
  }));
}